<div
  class="statement-filters-wrapper"
  [class.statement-filters-wrapper--expanded]="isExpanded()">
  <button
    type="button"
    class="statement-filters-wrapper__toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()">
    <span class="statement-filters-wrapper__toggle-label">
      <i class="pi pi-filter"></i>
      Filtros
    </span>
    <i class="pi" [ngClass]="isExpanded() ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
  </button>

  @if (isExpanded()) {
    <form
      [formGroup]="filterForm"
      class="statement-filters"
      animate.enter="statement-filters--enter"
      animate.leave="statement-filters--leave">
      <div class="statement-filters__field">
        <label class="form-label">Data inicial</label>
        <p-datePicker
          class="w-100"
          inputStyleClass="w-100"
          formControlName="startDate"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [selectOtherMonths]="true"
          [maxDate]="today"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa" />
        @if (filterForm.get("startDate")?.touched && filterForm.get("startDate")?.errors?.["futureDate"]) {
          <span class="statement-filters__error">A data inicial não pode estar no futuro.</span>
        }
      </div>

      <div class="statement-filters__field">
        <label class="form-label">Data final</label>
        <p-datePicker
          class="w-100"
          inputStyleClass="w-100"
          formControlName="endDate"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [selectOtherMonths]="true"
          [minDate]="filterForm.get('startDate')?.value || null"
          [maxDate]="today"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa" />
        @if (filterForm.get("endDate")?.touched && filterForm.get("endDate")?.errors?.["futureDate"]) {
          <span class="statement-filters__error">A data final não pode estar no futuro.</span>
        }
        @if (filterForm.touched && filterForm.errors?.["endBeforeStart"]) {
          <span class="statement-filters__error">A data final deve ser igual ou posterior à data inicial.</span>
        }
      </div>

      <div class="statement-filters__field">
        <label class="form-label">Meio de pagamento</label>
        <p-select
          class="w-100"
          formControlName="paymentMethod"
          [options]="paymentMethodOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos" />
      </div>

      <div class="statement-filters__field">
        <label class="form-label">Canal de pagamento</label>
        <p-select
          class="w-100"
          formControlName="paymentChannel"
          [options]="paymentChannelOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos" />
      </div>

      <div class="statement-filters__field">
        <label class="form-label">Direção</label>
        <p-select
          class="w-100"
          formControlName="direction"
          [options]="directionOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos" />
      </div>

      <div class="statement-filters__field statement-filters__field--full">
        <label class="form-label">Evento</label>
        <p-autoComplete
          class="w-100"
          inputStyleClass="w-100"
          formControlName="event"
          [suggestions]="(eventSuggestions$ | async) ?? []"
          (completeMethod)="handleEventSearch($event)"
          optionLabel="title"
          field="title"
          placeholder="Buscar por evento"
          emptyMessage="Nenhum evento encontrado">
          <ng-template let-event pTemplate="item">
            <span>{{ event.title }}</span>
          </ng-template>
        </p-autoComplete>
      </div>

      <div class="statement-filters__actions statement-filters__field--full">
        <app-button class="w-100" styleType="primary" (btnClick)="applyFilters()">
          <i class="pi pi-search"></i> Filtrar
        </app-button>
        <app-button class="w-100" styleType="outlined" (btnClick)="clearFilters()">
          <i class="pi pi-filter-slash"></i> Limpar
        </app-button>
      </div>
    </form>
  }
</div>
